<button
  *upsIfExportAllowed
  type="button"
  kendoGridExcelCommand
  icon="file-excel"
>
  {{ text() }}
</button>
